import React, { Component } from "react";
import FileUploader from "./FileUploader";

class FileUploaderContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFiles: []
    };

    this.promiseBarRef = React.createRef();
    this.inputRef = React.createRef();
  }

  onSelect = event => {
    let selectedFiles;

    if (this.props.multiple) {
      selectedFiles = event.fileList;
      this.props.onSelect(event.fileList);
    } else {
      this.props.onSelect(event.file);
      selectedFiles = [event.file];
    }

    selectedFiles.forEach(file => (file.status = "done"));
    this.setState({ selectedFiles });
    if (this.props.setSelected) {
      this.props.setSelected(true);
    }
  };

  onUpload = event => {
    if (event) {
      event.preventDefault();
    }

    if (this.state.selectedFiles && this.state.selectedFiles.length) {
      this.props.onUpload(
        this.state.selectedFiles.map(file => file.originFileObj)
      );
    }

    if (!this.props.isModal && !this.props.hideButtonAndBar) {
      //this line must be called after promise start!
      this.promiseBarRef.current.start();
    }
  };

  onError = () => {
    if (!this.props.hideButtonAndBar) {
      this.promiseBarRef.current.error();
    }
  };

  reset = () => {
    if (!this.props.isModal && !this.props.hideButtonAndBar) {
      this.promiseBarRef.current.reset();
    }
    if (this.inputRef.current !== null) {
      this.inputRef.current.value = "";
    }

    this.setState({ selectedFiles: [] });
  };

  hasSelected = () => {
    return this.state.selectedFiles.length > 0;
  };

  render() {
    return (
      <FileUploader
        multiple={this.props.multiple}
        selected={this.state.selectedFiles}
        onSelect={this.onSelect}
        onUpload={this.onUpload}
        promiseBarRef={this.promiseBarRef}
        inputRef={this.inputRef}
        disabled={this.props.disabled}
        isModal={this.props.isModal}
        hasSelected={this.hasSelected()}
        hideButtonAndBar={this.props.hideButtonAndBar}
      />
    );
  }
}

export default FileUploaderContainer;
